// src/components/AddBenefitModal/AddBenefitModalStyles.ts
const styles = {
  modal: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: '8px',
  },
  title: {
    mb: 2,
  },
  textField: {
    mb: 2,
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
    mt: 2,
  },
  cancelButton: {
    mr: 2,
  },
  addButton: {
    backgroundColor: '#5958e1',
    '&:hover': {
      backgroundColor: '#5958c0',
    },
  },
};

export default styles;
